var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileNotActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 17.85H15.24C14.44 17.85 13.68 18.16 13.12 18.72L11.41 20.41C10.63 21.18 9.36002 21.18 8.58002 20.41L6.87 18.72C6.31 18.16 5.54 17.85 4.75 17.85H4C2.34 17.85 1 16.52 1 14.88V3.96997C1 2.32997 2.34 1 4 1H16C17.66 1 19 2.32997 19 3.96997V14.88C19 16.51 17.66 17.85 16 17.85Z",
    stroke: "#AAAAAA",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 8.99005C11.2868 8.99005 12.33 7.94686 12.33 6.66003C12.33 5.37321 11.2868 4.33008 10 4.33008C8.71318 4.33008 7.66998 5.37321 7.66998 6.66003C7.66998 7.94686 8.71318 8.99005 10 8.99005Z",
    stroke: "#AAAAAA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 14.6501C14 12.8501 12.21 11.3901 10 11.3901C7.79 11.3901 6 12.8501 6 14.6501",
    stroke: "#AAAAAA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileNotActive);
export default __webpack_public_path__ + "static/media/profile-not-active.4623ec514651182770a3ce7f4851efea.svg";
export { ForwardRef as ReactComponent };